"use client";

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageSquare, Settings, Upload, Users } from "lucide-react";
import { Button } from "@vionixasia/shared-components";
import { AdminShell } from "@/components/AdminShell";
import { StatCard } from "@/components/StatCard";
import { apiClient } from "@/lib/api-client";
import { useQueryParam } from "@/lib/use-query-param";
import type { ResultEvent } from "@/types/event";

export default function EventPage() {
  const projectId = useQueryParam("projectId");
  const eventId = useQueryParam("eventId");
  const [event, setEvent] = useState<ResultEvent | null>(null);

  useEffect(() => {
    if (!projectId || !eventId) return;
    apiClient<{ event: ResultEvent }>(`/api/projects/${projectId}/events/${eventId}`).then((data) => setEvent(data.event));
  }, [projectId, eventId]);

  return (
    <AdminShell>
      {!event ? (
        <p className="text-sm text-muted">Loading event...</p>
      ) : (
        <>
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <h1 className="text-2xl font-semibold text-ink">{event.name}</h1>
              <p className="text-sm text-muted">{event.date} · {event.location || "No location"} · {event.status}</p>
            </div>
            <Button as={Link} variant="muted" to={`/results/view?eventSlug=${event.slug}&resultId=sample`} target="_blank">
              Public URL Pattern
            </Button>
          </div>
          <div className="mt-6 grid gap-4 sm:grid-cols-3">
            <StatCard label="Total Results" value={event.total_results || 0} />
            <StatCard label="WhatsApp Sent" value={event.total_whatsapp_sent || 0} />
            <StatCard label="Failed Message" value={event.total_whatsapp_failed || 0} />
          </div>
          <div className="mt-6 grid gap-4 md:grid-cols-4">
            <Link className="rounded-card border border-line bg-white p-4 hover:border-brand" to={`/dashboard/import?projectId=${projectId}&eventId=${event.id}`}>
              <Upload size={20} /><h2 className="mt-3 font-semibold">Import Result</h2><p className="mt-1 text-sm text-muted">Upload Excel, mapping, preview, validasi, lalu simpan.</p>
            </Link>
            <Link className="rounded-card border border-line bg-white p-4 hover:border-brand" to={`/dashboard/results?projectId=${projectId}&eventId=${event.id}`}>
              <Users size={20} /><h2 className="mt-3 font-semibold">Results</h2><p className="mt-1 text-sm text-muted">Kelola result dan kirim WhatsApp manual.</p>
            </Link>
            <Link className="rounded-card border border-line bg-white p-4 hover:border-brand" to={`/dashboard/whatsapp-logs?projectId=${projectId}&eventId=${event.id}`}>
              <MessageSquare size={20} /><h2 className="mt-3 font-semibold">WhatsApp Logs</h2><p className="mt-1 text-sm text-muted">Pantau delivery status dan error.</p>
            </Link>
            <div className="rounded-card border border-line bg-white p-4">
              <Settings size={20} /><h2 className="mt-3 font-semibold">Settings</h2><p className="mt-1 text-sm text-muted">Template: {event.whatsapp_template_name || "finish_result"}</p>
            </div>
          </div>
        </>
      )}
    </AdminShell>
  );
}
